/**
 * Impression Submission Form V2 Handler
 * Multi-step wizard with progress bar
 * Handles photo uploads and form submission to Salesforce API
 */
(function() {
  'use strict';

  // Max file size: 10MB
  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];

  // Label configurations based on preference selection
  const LABEL_CONFIG = {
    '1 top & 1 bottom': {
      showBox2: true,
      box1: { label: 'Upload your TOP impression', guideType: 'top', photoType: 'top' },
      box2: { label: 'Upload your BOTTOM impression', guideType: 'bottom', photoType: 'bottom' }
    },
    '2 tops': {
      showBox2: false,
      box1: { label: 'Upload your TOP impressions', guideType: 'top', photoType: 'top' },
      box2: null
    },
    '2 bottoms': {
      showBox2: false,
      box1: { label: 'Upload your BOTTOM impressions', guideType: 'bottom', photoType: 'bottom' },
      box2: null
    }
  };

  // US States and Territories data (matching remi/customerFormSiteV2)
  const US_STATES = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
    // US Territories
    { label: 'American Samoa', value: 'AS' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Guam', value: 'GU' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'U.S. Virgin Islands', value: 'VI' }
  ];

  // ZIP Code prefix to state mapping (first 3 digits)
  const ZIP_TO_STATE = {
    '005': 'NY', '006': 'PR', '007': 'PR', '008': 'VI', '009': 'PR',
    '010': 'MA', '011': 'MA', '012': 'MA', '013': 'MA', '014': 'MA', '015': 'MA',
    '016': 'MA', '017': 'MA', '018': 'MA', '019': 'MA', '020': 'MA', '021': 'MA',
    '022': 'MA', '023': 'MA', '024': 'MA', '025': 'MA', '026': 'MA', '027': 'MA',
    '028': 'RI', '029': 'RI',
    '030': 'NH', '031': 'NH', '032': 'NH', '033': 'NH', '034': 'NH', '035': 'NH',
    '036': 'NH', '037': 'NH', '038': 'NH',
    '039': 'ME', '040': 'ME', '041': 'ME', '042': 'ME', '043': 'ME', '044': 'ME',
    '045': 'ME', '046': 'ME', '047': 'ME', '048': 'ME', '049': 'ME',
    '050': 'VT', '051': 'VT', '052': 'VT', '053': 'VT', '054': 'VT', '055': 'MA',
    '056': 'VT', '057': 'VT', '058': 'VT', '059': 'VT',
    '060': 'CT', '061': 'CT', '062': 'CT', '063': 'CT', '064': 'CT', '065': 'CT',
    '066': 'CT', '067': 'CT', '068': 'CT', '069': 'CT',
    '070': 'NJ', '071': 'NJ', '072': 'NJ', '073': 'NJ', '074': 'NJ', '075': 'NJ',
    '076': 'NJ', '077': 'NJ', '078': 'NJ', '079': 'NJ', '080': 'NJ', '081': 'NJ',
    '082': 'NJ', '083': 'NJ', '084': 'NJ', '085': 'NJ', '086': 'NJ', '087': 'NJ',
    '088': 'NJ', '089': 'NJ',
    '100': 'NY', '101': 'NY', '102': 'NY', '103': 'NY', '104': 'NY', '105': 'NY',
    '106': 'NY', '107': 'NY', '108': 'NY', '109': 'NY', '110': 'NY', '111': 'NY',
    '112': 'NY', '113': 'NY', '114': 'NY', '115': 'NY', '116': 'NY', '117': 'NY',
    '118': 'NY', '119': 'NY', '120': 'NY', '121': 'NY', '122': 'NY', '123': 'NY',
    '124': 'NY', '125': 'NY', '126': 'NY', '127': 'NY', '128': 'NY', '129': 'NY',
    '130': 'NY', '131': 'NY', '132': 'NY', '133': 'NY', '134': 'NY', '135': 'NY',
    '136': 'NY', '137': 'NY', '138': 'NY', '139': 'NY', '140': 'NY', '141': 'NY',
    '142': 'NY', '143': 'NY', '144': 'NY', '145': 'NY', '146': 'NY', '147': 'NY',
    '148': 'NY', '149': 'NY',
    '150': 'PA', '151': 'PA', '152': 'PA', '153': 'PA', '154': 'PA', '155': 'PA',
    '156': 'PA', '157': 'PA', '158': 'PA', '159': 'PA', '160': 'PA', '161': 'PA',
    '162': 'PA', '163': 'PA', '164': 'PA', '165': 'PA', '166': 'PA', '167': 'PA',
    '168': 'PA', '169': 'PA', '170': 'PA', '171': 'PA', '172': 'PA', '173': 'PA',
    '174': 'PA', '175': 'PA', '176': 'PA', '177': 'PA', '178': 'PA', '179': 'PA',
    '180': 'PA', '181': 'PA', '182': 'PA', '183': 'PA', '184': 'PA', '185': 'PA',
    '186': 'PA', '187': 'PA', '188': 'PA', '189': 'PA', '190': 'PA', '191': 'PA',
    '192': 'PA', '193': 'PA', '194': 'PA', '195': 'PA', '196': 'PA',
    '197': 'DE', '198': 'DE', '199': 'DE',
    '200': 'DC', '201': 'VA', '202': 'DC', '203': 'DC', '204': 'DC', '205': 'DC',
    '206': 'MD', '207': 'MD', '208': 'MD', '209': 'MD', '210': 'MD', '211': 'MD',
    '212': 'MD', '214': 'MD', '215': 'MD', '216': 'MD', '217': 'MD', '218': 'MD', '219': 'MD',
    '220': 'VA', '221': 'VA', '222': 'VA', '223': 'VA', '224': 'VA', '225': 'VA',
    '226': 'VA', '227': 'VA', '228': 'VA', '229': 'VA', '230': 'VA', '231': 'VA',
    '232': 'VA', '233': 'VA', '234': 'VA', '235': 'VA', '236': 'VA', '237': 'VA',
    '238': 'VA', '239': 'VA', '240': 'VA', '241': 'VA', '242': 'VA', '243': 'VA',
    '244': 'VA', '245': 'VA', '246': 'VA',
    '247': 'WV', '248': 'WV', '249': 'WV', '250': 'WV', '251': 'WV', '252': 'WV',
    '253': 'WV', '254': 'WV', '255': 'WV', '256': 'WV', '257': 'WV', '258': 'WV',
    '259': 'WV', '260': 'WV', '261': 'WV', '262': 'WV', '263': 'WV', '264': 'WV',
    '265': 'WV', '266': 'WV', '267': 'WV', '268': 'WV',
    '270': 'NC', '271': 'NC', '272': 'NC', '273': 'NC', '274': 'NC', '275': 'NC',
    '276': 'NC', '277': 'NC', '278': 'NC', '279': 'NC', '280': 'NC', '281': 'NC',
    '282': 'NC', '283': 'NC', '284': 'NC', '285': 'NC', '286': 'NC', '287': 'NC',
    '288': 'NC', '289': 'NC',
    '290': 'SC', '291': 'SC', '292': 'SC', '293': 'SC', '294': 'SC', '295': 'SC',
    '296': 'SC', '297': 'SC', '298': 'SC', '299': 'SC',
    '300': 'GA', '301': 'GA', '302': 'GA', '303': 'GA', '304': 'GA', '305': 'GA',
    '306': 'GA', '307': 'GA', '308': 'GA', '309': 'GA', '310': 'GA', '311': 'GA',
    '312': 'GA', '313': 'GA', '314': 'GA', '315': 'GA', '316': 'GA', '317': 'GA',
    '318': 'GA', '319': 'GA', '398': 'GA', '399': 'GA',
    '320': 'FL', '321': 'FL', '322': 'FL', '323': 'FL', '324': 'FL', '325': 'FL',
    '326': 'FL', '327': 'FL', '328': 'FL', '329': 'FL', '330': 'FL', '331': 'FL',
    '332': 'FL', '333': 'FL', '334': 'FL', '335': 'FL', '336': 'FL', '337': 'FL',
    '338': 'FL', '339': 'FL',
    '350': 'AL', '351': 'AL', '352': 'AL', '354': 'AL', '355': 'AL', '356': 'AL',
    '357': 'AL', '358': 'AL', '359': 'AL', '360': 'AL', '361': 'AL', '362': 'AL',
    '363': 'AL', '364': 'AL', '365': 'AL', '366': 'AL', '367': 'AL', '368': 'AL', '369': 'AL',
    '370': 'TN', '371': 'TN', '372': 'TN', '373': 'TN', '374': 'TN', '375': 'TN',
    '376': 'TN', '377': 'TN', '378': 'TN', '379': 'TN', '380': 'TN', '381': 'TN',
    '382': 'TN', '383': 'TN', '384': 'TN', '385': 'TN',
    '386': 'MS', '387': 'MS', '388': 'MS', '389': 'MS', '390': 'MS', '391': 'MS',
    '392': 'MS', '393': 'MS', '394': 'MS', '395': 'MS', '396': 'MS', '397': 'MS',
    '400': 'KY', '401': 'KY', '402': 'KY', '403': 'KY', '404': 'KY', '405': 'KY',
    '406': 'KY', '407': 'KY', '408': 'KY', '409': 'KY', '410': 'KY', '411': 'KY',
    '412': 'KY', '413': 'KY', '414': 'KY', '415': 'KY', '416': 'KY', '417': 'KY',
    '418': 'KY', '420': 'KY', '421': 'KY', '422': 'KY', '423': 'KY', '424': 'KY',
    '425': 'KY', '426': 'KY', '427': 'KY',
    '430': 'OH', '431': 'OH', '432': 'OH', '433': 'OH', '434': 'OH', '435': 'OH',
    '436': 'OH', '437': 'OH', '438': 'OH', '439': 'OH', '440': 'OH', '441': 'OH',
    '442': 'OH', '443': 'OH', '444': 'OH', '445': 'OH', '446': 'OH', '447': 'OH',
    '448': 'OH', '449': 'OH', '450': 'OH', '451': 'OH', '452': 'OH', '453': 'OH',
    '454': 'OH', '455': 'OH', '456': 'OH', '457': 'OH', '458': 'OH',
    '460': 'IN', '461': 'IN', '462': 'IN', '463': 'IN', '464': 'IN', '465': 'IN',
    '466': 'IN', '467': 'IN', '468': 'IN', '469': 'IN', '470': 'IN', '471': 'IN',
    '472': 'IN', '473': 'IN', '474': 'IN', '475': 'IN', '476': 'IN', '477': 'IN',
    '478': 'IN', '479': 'IN',
    '480': 'MI', '481': 'MI', '482': 'MI', '483': 'MI', '484': 'MI', '485': 'MI',
    '486': 'MI', '487': 'MI', '488': 'MI', '489': 'MI', '490': 'MI', '491': 'MI',
    '492': 'MI', '493': 'MI', '494': 'MI', '495': 'MI', '496': 'MI', '497': 'MI',
    '498': 'MI', '499': 'MI',
    '500': 'IA', '501': 'IA', '502': 'IA', '503': 'IA', '504': 'IA', '505': 'IA',
    '506': 'IA', '507': 'IA', '508': 'IA', '509': 'IA', '510': 'IA', '511': 'IA',
    '512': 'IA', '513': 'IA', '514': 'IA', '515': 'IA', '516': 'IA', '520': 'IA',
    '521': 'IA', '522': 'IA', '523': 'IA', '524': 'IA', '525': 'IA', '526': 'IA',
    '527': 'IA', '528': 'IA',
    '530': 'WI', '531': 'WI', '532': 'WI', '534': 'WI', '535': 'WI', '537': 'WI',
    '538': 'WI', '539': 'WI', '540': 'WI', '541': 'WI', '542': 'WI', '543': 'WI',
    '544': 'WI', '545': 'WI', '546': 'WI', '547': 'WI', '548': 'WI', '549': 'WI',
    '550': 'MN', '551': 'MN', '553': 'MN', '554': 'MN', '555': 'MN', '556': 'MN',
    '557': 'MN', '558': 'MN', '559': 'MN', '560': 'MN', '561': 'MN', '562': 'MN',
    '563': 'MN', '564': 'MN', '565': 'MN', '566': 'MN', '567': 'MN',
    '570': 'SD', '571': 'SD', '572': 'SD', '573': 'SD', '574': 'SD', '575': 'SD',
    '576': 'SD', '577': 'SD',
    '580': 'ND', '581': 'ND', '582': 'ND', '583': 'ND', '584': 'ND', '585': 'ND',
    '586': 'ND', '587': 'ND', '588': 'ND',
    '590': 'MT', '591': 'MT', '592': 'MT', '593': 'MT', '594': 'MT', '595': 'MT',
    '596': 'MT', '597': 'MT', '598': 'MT', '599': 'MT',
    '600': 'IL', '601': 'IL', '602': 'IL', '603': 'IL', '604': 'IL', '605': 'IL',
    '606': 'IL', '607': 'IL', '608': 'IL', '609': 'IL', '610': 'IL', '611': 'IL',
    '612': 'IL', '613': 'IL', '614': 'IL', '615': 'IL', '616': 'IL', '617': 'IL',
    '618': 'IL', '619': 'IL', '620': 'IL', '622': 'IL', '623': 'IL', '624': 'IL',
    '625': 'IL', '626': 'IL', '627': 'IL', '628': 'IL', '629': 'IL',
    '630': 'MO', '631': 'MO', '633': 'MO', '634': 'MO', '635': 'MO', '636': 'MO',
    '637': 'MO', '638': 'MO', '639': 'MO', '640': 'MO', '641': 'MO', '644': 'MO',
    '645': 'MO', '646': 'MO', '647': 'MO', '648': 'MO', '649': 'MO', '650': 'MO',
    '651': 'MO', '652': 'MO', '653': 'MO', '654': 'MO', '655': 'MO', '656': 'MO',
    '657': 'MO', '658': 'MO',
    '660': 'KS', '661': 'KS', '662': 'KS', '664': 'KS', '665': 'KS', '666': 'KS',
    '667': 'KS', '668': 'KS', '669': 'KS', '670': 'KS', '671': 'KS', '672': 'KS',
    '673': 'KS', '674': 'KS', '675': 'KS', '676': 'KS', '677': 'KS', '678': 'KS', '679': 'KS',
    '680': 'NE', '681': 'NE', '683': 'NE', '684': 'NE', '685': 'NE', '686': 'NE',
    '687': 'NE', '688': 'NE', '689': 'NE', '690': 'NE', '691': 'NE', '692': 'NE', '693': 'NE',
    '700': 'LA', '701': 'LA', '703': 'LA', '704': 'LA', '705': 'LA', '706': 'LA',
    '707': 'LA', '708': 'LA', '710': 'LA', '711': 'LA', '712': 'LA', '713': 'LA', '714': 'LA',
    '716': 'AR', '717': 'AR', '718': 'AR', '719': 'AR', '720': 'AR', '721': 'AR',
    '722': 'AR', '723': 'AR', '724': 'AR', '725': 'AR', '726': 'AR', '727': 'AR',
    '728': 'AR', '729': 'AR',
    '730': 'OK', '731': 'OK', '733': 'OK', '734': 'OK', '735': 'OK', '736': 'OK',
    '737': 'OK', '738': 'OK', '739': 'OK', '740': 'OK', '741': 'OK', '743': 'OK',
    '744': 'OK', '745': 'OK', '746': 'OK', '747': 'OK', '748': 'OK', '749': 'OK',
    '750': 'TX', '751': 'TX', '752': 'TX', '753': 'TX', '754': 'TX', '755': 'TX',
    '756': 'TX', '757': 'TX', '758': 'TX', '759': 'TX', '760': 'TX', '761': 'TX',
    '762': 'TX', '763': 'TX', '764': 'TX', '765': 'TX', '766': 'TX', '767': 'TX',
    '768': 'TX', '769': 'TX', '770': 'TX', '772': 'TX', '773': 'TX', '774': 'TX',
    '775': 'TX', '776': 'TX', '777': 'TX', '778': 'TX', '779': 'TX', '780': 'TX',
    '781': 'TX', '782': 'TX', '783': 'TX', '784': 'TX', '785': 'TX', '786': 'TX',
    '787': 'TX', '788': 'TX', '789': 'TX', '790': 'TX', '791': 'TX', '792': 'TX',
    '793': 'TX', '794': 'TX', '795': 'TX', '796': 'TX', '797': 'TX', '798': 'TX', '799': 'TX',
    '800': 'CO', '801': 'CO', '802': 'CO', '803': 'CO', '804': 'CO', '805': 'CO',
    '806': 'CO', '807': 'CO', '808': 'CO', '809': 'CO', '810': 'CO', '811': 'CO',
    '812': 'CO', '813': 'CO', '814': 'CO', '815': 'CO', '816': 'CO',
    '820': 'WY', '821': 'WY', '822': 'WY', '823': 'WY', '824': 'WY', '825': 'WY',
    '826': 'WY', '827': 'WY', '828': 'WY', '829': 'WY', '830': 'WY', '831': 'WY',
    '832': 'ID', '833': 'ID', '834': 'ID', '835': 'ID', '836': 'ID', '837': 'ID', '838': 'ID',
    '840': 'UT', '841': 'UT', '842': 'UT', '843': 'UT', '844': 'UT', '845': 'UT',
    '846': 'UT', '847': 'UT',
    '850': 'AZ', '851': 'AZ', '852': 'AZ', '853': 'AZ', '855': 'AZ', '856': 'AZ',
    '857': 'AZ', '858': 'AZ', '859': 'AZ', '860': 'AZ', '863': 'AZ', '864': 'AZ', '865': 'AZ',
    '870': 'NM', '871': 'NM', '872': 'NM', '873': 'NM', '874': 'NM', '875': 'NM',
    '877': 'NM', '878': 'NM', '879': 'NM', '880': 'NM', '881': 'NM', '882': 'NM',
    '883': 'NM', '884': 'NM',
    '889': 'NV', '890': 'NV', '891': 'NV', '893': 'NV', '894': 'NV', '895': 'NV',
    '897': 'NV', '898': 'NV',
    '900': 'CA', '901': 'CA', '902': 'CA', '903': 'CA', '904': 'CA', '905': 'CA',
    '906': 'CA', '907': 'CA', '908': 'CA', '910': 'CA', '911': 'CA', '912': 'CA',
    '913': 'CA', '914': 'CA', '915': 'CA', '916': 'CA', '917': 'CA', '918': 'CA',
    '919': 'CA', '920': 'CA', '921': 'CA', '922': 'CA', '923': 'CA', '924': 'CA',
    '925': 'CA', '926': 'CA', '927': 'CA', '928': 'CA', '930': 'CA', '931': 'CA',
    '932': 'CA', '933': 'CA', '934': 'CA', '935': 'CA', '936': 'CA', '937': 'CA',
    '938': 'CA', '939': 'CA', '940': 'CA', '941': 'CA', '942': 'CA', '943': 'CA',
    '944': 'CA', '945': 'CA', '946': 'CA', '947': 'CA', '948': 'CA', '949': 'CA',
    '950': 'CA', '951': 'CA', '952': 'CA', '953': 'CA', '954': 'CA', '955': 'CA',
    '956': 'CA', '957': 'CA', '958': 'CA', '959': 'CA', '960': 'CA', '961': 'CA',
    '967': 'HI', '968': 'HI',
    '969': 'GU',
    '970': 'OR', '971': 'OR', '972': 'OR', '973': 'OR', '974': 'OR', '975': 'OR',
    '976': 'OR', '977': 'OR', '978': 'OR', '979': 'OR',
    '980': 'WA', '981': 'WA', '982': 'WA', '983': 'WA', '984': 'WA', '985': 'WA',
    '986': 'WA', '988': 'WA', '989': 'WA', '990': 'WA', '991': 'WA', '992': 'WA',
    '993': 'WA', '994': 'WA',
    '995': 'AK', '996': 'AK', '997': 'AK', '998': 'AK', '999': 'AK'
  };

  // Get state code from ZIP prefix
  function getStateFromZip(zip) {
    if (!zip || zip.length < 3) return null;
    const prefix = zip.replace(/\D/g, '').substring(0, 3);
    return ZIP_TO_STATE[prefix] || null;
  }

  // Initialize state combobox (searchable dropdown)
  function initStateCombobox(form) {
    const combobox = form.querySelector('[data-state-combobox]');
    if (!combobox) return null;

    const input = combobox.querySelector('[data-state-input]');
    const hiddenInput = combobox.querySelector('[data-state-value]');
    const dropdown = combobox.querySelector('[data-state-dropdown]');

    if (!input || !hiddenInput || !dropdown) return null;

    let highlightedIndex = -1;
    let filteredStates = [...US_STATES];

    // Render dropdown options
    function renderOptions(states) {
      if (states.length === 0) {
        dropdown.innerHTML = '<div class="impression-form-v2__state-no-results">No states found</div>';
        return;
      }

      dropdown.innerHTML = states.map((state) => `
        <div class="impression-form-v2__state-option"
             role="option"
             data-value="${state.value}"
             data-label="${state.label}"
             aria-selected="${hiddenInput.value === state.value}">
          <span>${state.label}</span>
          <span class="impression-form-v2__state-option-code">${state.value}</span>
        </div>
      `).join('');

      // Add click listeners
      dropdown.querySelectorAll('.impression-form-v2__state-option').forEach(option => {
        option.addEventListener('click', () => selectState(option.dataset.value, option.dataset.label));
      });
    }

    function selectState(value, label, isAutofill = false) {
      hiddenInput.value = value;
      input.value = label;
      closeDropdown();
      combobox.dataset.wasAutofilled = isAutofill ? 'true' : 'false';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function openDropdown() {
      combobox.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      highlightedIndex = -1;
    }

    function closeDropdown() {
      combobox.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      highlightedIndex = -1;
    }

    function filterStates(query) {
      const q = query.toLowerCase().trim();
      if (!q) {
        filteredStates = [...US_STATES];
      } else {
        filteredStates = US_STATES.filter(state =>
          state.label.toLowerCase().includes(q) ||
          state.value.toLowerCase().includes(q)
        );
      }
      renderOptions(filteredStates);
    }

    function highlightOption(index) {
      const options = dropdown.querySelectorAll('.impression-form-v2__state-option');
      options.forEach((opt, i) => opt.classList.toggle('is-highlighted', i === index));
      if (options[index]) {
        options[index].scrollIntoView({ block: 'nearest' });
      }
    }

    // Event listeners
    input.addEventListener('focus', () => {
      filterStates(input.value);
      openDropdown();
    });

    input.addEventListener('input', (e) => {
      filterStates(e.target.value);
      openDropdown();
      combobox.dataset.wasAutofilled = 'false';
    });

    input.addEventListener('keydown', (e) => {
      const options = dropdown.querySelectorAll('.impression-form-v2__state-option');

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!combobox.classList.contains('is-open')) {
            openDropdown();
          }
          highlightedIndex = Math.min(highlightedIndex + 1, options.length - 1);
          highlightOption(highlightedIndex);
          break;
        case 'ArrowUp':
          e.preventDefault();
          highlightedIndex = Math.max(highlightedIndex - 1, 0);
          highlightOption(highlightedIndex);
          break;
        case 'Enter':
          e.preventDefault();
          if (highlightedIndex >= 0 && options[highlightedIndex]) {
            const opt = options[highlightedIndex];
            selectState(opt.dataset.value, opt.dataset.label);
          } else if (filteredStates.length === 1) {
            selectState(filteredStates[0].value, filteredStates[0].label);
          }
          break;
        case 'Escape':
          closeDropdown();
          break;
        case 'Tab':
          closeDropdown();
          break;
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!combobox.contains(e.target)) {
        closeDropdown();
        // Validate selection on blur
        if (input.value && !hiddenInput.value) {
          const match = US_STATES.find(s =>
            s.label.toLowerCase() === input.value.toLowerCase() ||
            s.value.toLowerCase() === input.value.toLowerCase()
          );
          if (match) {
            selectState(match.value, match.label);
          } else {
            input.value = '';
          }
        }
      }
    });

    // Initial render
    renderOptions(US_STATES);

    // Return API for external use
    return {
      setState: (code, isAutofill = false) => {
        const state = US_STATES.find(s => s.value === code || s.value === code.toUpperCase());
        if (state) {
          selectState(state.value, state.label, isAutofill);
        }
      },
      getValue: () => hiddenInput.value,
      wasAutofilled: () => combobox.dataset.wasAutofilled === 'true'
    };
  }

  // Initialize ZIP to state auto-fill
  function initZipAutoFill(form, stateCombobox) {
    if (!stateCombobox) return;

    const zipInput = form.querySelector('[name="shippingZip"]');
    if (!zipInput) return;

    zipInput.addEventListener('input', (e) => {
      const zip = e.target.value.replace(/\D/g, '');
      if (zip.length >= 3) {
        const stateCode = getStateFromZip(zip);
        if (stateCode) {
          const currentValue = stateCombobox.getValue();
          // Only auto-fill if empty or was previously auto-filled
          if (!currentValue || stateCombobox.wasAutofilled()) {
            stateCombobox.setState(stateCode, true);
          }
        }
      }
    });
  }

  // Initialize all impression forms on the page
  function init() {
    const forms = document.querySelectorAll('[data-impression-form-v2]');
    forms.forEach(initForm);
  }

  function initForm(form) {
    // Store files per upload box (Map per box)
    const filesBox1 = new Map();
    const filesBox2 = new Map();

    // Track current stage
    let currentStage = 1;

    const uploadBoxes = form.querySelector('[data-upload-boxes]');
    const box1 = form.querySelector('[data-upload-box="1"]');
    const box2 = form.querySelector('[data-upload-box="2"]');
    const preferenceSelect = form.querySelector('[name="guardSelection"]');
    const lightbox = form.closest('.impression-form-v2').querySelector('[data-lightbox]');
    const thankYouModal = form.closest('.impression-form-v2').querySelector('[data-thank-you-modal]');
    const welcomeModal = form.closest('.impression-form-v2').querySelector('[data-welcome-modal]');
    const ageWarningModal = form.closest('.impression-form-v2').querySelector('[data-age-warning-modal]');
    const progressBar = form.closest('.impression-form-v2').querySelector('[data-progress-bar]');
    const lookupEndpoint = form.dataset.salesforceLookupEndpoint;

    // Stage navigation elements
    const nextBtns = form.querySelectorAll('[data-next-btn]');
    const backBtns = form.querySelectorAll('[data-back-btn]');
    const stages = form.querySelectorAll('[data-stage]');
    const progressSteps = progressBar ? progressBar.querySelectorAll('[data-progress-step]') : [];
    const progressConnectors = progressBar ? progressBar.querySelectorAll('[data-progress-connector]') : [];
    const totalStages = 4;

    if (!uploadBoxes || !box1 || !box2 || !preferenceSelect) return;

    // Initialize tooltip triggers for mobile tap support
    initTooltips(form);

    // Initialize upload box 1
    initUploadBox(box1, filesBox1, form);

    // Initialize upload box 2
    initUploadBox(box2, filesBox2, form);

    // Initialize lightbox handlers
    if (lightbox) {
      initLightbox(lightbox, form);
    }

    // Initialize thank you modal handlers
    if (thankYouModal) {
      initThankYouModal(thankYouModal, form, filesBox1, filesBox2, uploadBoxes, () => {
        // Reset to stage 1 after form reset
        goToStage(1, stages, progressSteps, progressConnectors, totalStages);
        currentStage = 1;
      });
    }

    // Initialize welcome back modal handlers
    if (welcomeModal) {
      initWelcomeModal(welcomeModal, form);
    }

    // Initialize age warning modal handlers
    if (ageWarningModal) {
      initAgeWarningModal(ageWarningModal, form);
    }

    // Email lookup on blur (check for existing customer)
    const emailField = form.querySelector('[name="email"]');
    if (emailField && lookupEndpoint) {
      emailField.addEventListener('blur', () => {
        const email = emailField.value.trim();
        if (email && isValidEmail(email)) {
          lookupCustomerByEmail(email, lookupEndpoint, welcomeModal, form);
        }
      });
    }

    // Date of birth validation (under 13 warning)
    const dobField = form.querySelector('[name="dateOfBirth"]');
    if (dobField && ageWarningModal) {
      dobField.addEventListener('change', () => {
        const dob = dobField.value;
        const minAge = parseInt(form.dataset.minAge) || 13;
        if (dob && isUnderAge(dob, minAge)) {
          showAgeWarningModal(ageWarningModal);
        }
      });
    }

    // Product card selection
    initProductCards(form);

    // Guard selection -> dynamic backup options
    initGuardSelection(form);

    // Thickness bar selection
    initThicknessBar(form);

    // Date of birth dropdowns
    initDobDropdowns(form);

    // Impressions Approved on Zoom checkbox toggle
    const zoomApprovedCheckbox = form.querySelector('[data-zoom-approved]');
    if (zoomApprovedCheckbox) {
      zoomApprovedCheckbox.addEventListener('change', () => {
        const wrapper = form.querySelector('[data-zoom-approved-wrapper]');
        const notice = form.querySelector('[data-zoom-notice]');
        if (zoomApprovedCheckbox.checked) {
          if (wrapper) wrapper.classList.add('is-checked');
          if (uploadBoxes) uploadBoxes.classList.remove('is-visible');
          if (notice) notice.classList.add('is-visible');
        } else {
          if (wrapper) wrapper.classList.remove('is-checked');
          if (notice) notice.classList.remove('is-visible');
          // Re-show upload boxes based on current guard selection
          const currentPreference = preferenceSelect?.value;
          if (currentPreference && LABEL_CONFIG[currentPreference]) {
            updateUploadBoxes(currentPreference, box1, box2, uploadBoxes, form);
          }
        }
      });
    }

    // Tracking number formatting
    initTrackingNumberFormat(form);

    // Phone number formatting
    initPhoneFormat(form);

    // State combobox (searchable dropdown with ZIP auto-fill)
    const stateCombobox = initStateCombobox(form);
    initZipAutoFill(form, stateCombobox);

    // Store state combobox API on form for external access
    form.stateComboboxAPI = stateCombobox;

    // Real-time field error clearing on user interaction
    form.addEventListener('input', (e) => {
      if (e.target.name) clearFieldError(form, e.target.name);
    });
    form.addEventListener('change', (e) => {
      if (e.target.name) clearFieldError(form, e.target.name);
      // Clear DOB wrapper error when any DOB dropdown changes
      if (e.target.name === 'dobMonth' || e.target.name === 'dobDay' || e.target.name === 'dobYear') {
        clearErrorOnWrapper(form.querySelector('[data-dob-row]'));
      }
      // Clear state combobox error when state changes
      if (e.target.name === 'shippingStateDisplay') {
        clearErrorOnWrapper(form.querySelector('[data-state-combobox]'));
      }
    });

    // Next buttons - go to next stage
    nextBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const fromStage = parseInt(btn.dataset.nextBtn);
        const toStage = fromStage + 1;

        if (validateStage(fromStage, form, filesBox1, filesBox2)) {
          goToStage(toStage, stages, progressSteps, progressConnectors, totalStages);
          currentStage = toStage;
        }
      });
    });

    // Back buttons - go to previous stage
    backBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const fromStage = parseInt(btn.dataset.backBtn);
        const toStage = fromStage - 1;
        goToStage(toStage, stages, progressSteps, progressConnectors, totalStages);
        currentStage = toStage;
      });
    });

    // Progress step clicks - navigate to completed/active stages
    progressSteps.forEach(step => {
      step.addEventListener('click', () => {
        const targetStage = parseInt(step.dataset.progressStep);

        // Can only navigate to stages we've already visited
        if (targetStage < currentStage) {
          goToStage(targetStage, stages, progressSteps, progressConnectors, totalStages);
          currentStage = targetStage;
        }
      });
    });

    // Form submission
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (validateStage4(form, filesBox1, filesBox2)) {
        submitForm(form, filesBox1, filesBox2, thankYouModal);
      }
    });
  }

  // Validate any stage
  function validateStage(stageNumber, form, filesBox1, filesBox2) {
    switch (stageNumber) {
      case 1: return validateStage1(form);
      case 2: return validateStage2(form);
      case 3: return validateStage3(form);
      case 4: return validateStage4(form, filesBox1, filesBox2);
      default: return true;
    }
  }

  function goToStage(stageNumber, stages, progressSteps, progressConnectors, totalStages) {
    // Update stage visibility
    stages.forEach(stage => {
      const stageNum = parseInt(stage.dataset.stage);
      stage.classList.toggle('is-active', stageNum === stageNumber);
    });

    // Update progress bar steps
    progressSteps.forEach(step => {
      const stepNum = parseInt(step.dataset.progressStep);
      step.classList.remove('is-active', 'is-completed', 'is-disabled');

      if (stepNum < stageNumber) {
        step.classList.add('is-completed');
      } else if (stepNum === stageNumber) {
        step.classList.add('is-active');
      } else {
        step.classList.add('is-disabled');
      }
    });

    // Update connectors
    progressConnectors.forEach(connector => {
      const connectorNum = parseInt(connector.dataset.progressConnector);
      connector.classList.toggle('is-completed', connectorNum < stageNumber);
    });

    // Scroll to top of form smoothly
    const formContainer = stages[0].closest('.impression-form-v2');
    if (formContainer) {
      formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Stage 1: Personal Information
  function validateStage1(form) {
    clearAllFieldErrors(form);
    hideMessages(form);
    let valid = true;

    const email = form.querySelector('[name="email"]')?.value.trim();
    const firstName = form.querySelector('[name="firstName"]')?.value.trim();
    const lastName = form.querySelector('[name="lastName"]')?.value.trim();
    const phone = form.querySelector('[name="phone"]')?.value.trim();
    const dob = form.querySelector('[name="dateOfBirth"]')?.value;

    if (!email) {
      showFieldError(form, 'email', 'Please enter your email address.');
      valid = false;
    } else if (!isValidEmail(email)) {
      showFieldError(form, 'email', 'Please enter a valid email address.');
      valid = false;
    }
    if (!firstName) {
      showFieldError(form, 'firstName', 'Please enter your first name.');
      valid = false;
    }
    if (!lastName) {
      showFieldError(form, 'lastName', 'Please enter your last name.');
      valid = false;
    }
    if (!phone) {
      showFieldError(form, 'phone', 'Please enter your phone number.');
      valid = false;
    }
    if (!dob) {
      const dobRow = form.querySelector('[data-dob-row]');
      showErrorOnWrapper(dobRow, 'Please select your date of birth.');
      valid = false;
    }

    if (!valid) scrollToFirstError(form);
    return valid;
  }

  // Stage 2: Shipping Address
  function validateStage2(form) {
    clearAllFieldErrors(form);
    hideMessages(form);
    let valid = true;

    const address1 = form.querySelector('[name="shippingAddress1"]')?.value.trim();
    const city = form.querySelector('[name="shippingCity"]')?.value.trim();
    const state = form.querySelector('[name="shippingState"]')?.value.trim();
    const zip = form.querySelector('[name="shippingZip"]')?.value.trim();

    if (!address1) {
      showFieldError(form, 'shippingAddress1', 'Please enter your street address.');
      valid = false;
    }
    if (!city) {
      showFieldError(form, 'shippingCity', 'Please enter your city.');
      valid = false;
    }
    if (!state) {
      const stateCombobox = form.querySelector('[data-state-combobox]');
      showErrorOnWrapper(stateCombobox, 'Please select your state.');
      valid = false;
    }
    if (!zip) {
      showFieldError(form, 'shippingZip', 'Please enter your ZIP code.');
      valid = false;
    }

    if (!valid) scrollToFirstError(form);
    return valid;
  }

  // Stage 3: Order Details
  function validateStage3(form) {
    clearAllFieldErrors(form);
    hideMessages(form);
    let valid = true;

    const selectedProduct = form.querySelector('[data-selected-product]')?.value;
    const guardSelection = form.querySelector('[name="guardSelection"]')?.value;
    const backupOption = form.querySelector('[name="backupOption"]')?.value;
    const guardThickness = form.querySelector('[data-guard-thickness]')?.value;
    const orderNumber = form.querySelector('[name="orderNumber"]')?.value.trim();

    if (!guardSelection) {
      showFieldError(form, 'guardSelection', 'Please select your first choice.');
      valid = false;
    }
    const backupSelect = form.querySelector('[name="backupOption"]');
    if (backupSelect && !backupSelect.disabled && !backupOption) {
      showFieldError(form, 'backupOption', 'Please select your backup choice.');
      const backupHint = form.querySelector('[data-backup-hint]');
      if (backupHint) backupHint.style.display = 'none';
      valid = false;
    }
    if (selectedProduct === 'nightGuard' && !guardThickness) {
      const thicknessBar = form.querySelector('[data-thickness-bar]');
      showErrorOnWrapper(thicknessBar, 'Please select a guard thickness.');
      valid = false;
    }

    if (!valid) scrollToFirstError(form);
    return valid;
  }

  // Stage 4: Photos & Return Info
  function validateStage4(form, filesBox1, filesBox2) {
    clearAllFieldErrors(form);
    hideMessages(form);
    let valid = true;

    const trackingNumber = form.querySelector('[name="trackingNumber"]')?.value.replace(/\s/g, '');
    const guardSelection = form.querySelector('[name="guardSelection"]')?.value;
    const zoomApproved = form.querySelector('[data-zoom-approved]')?.checked || false;

    if (trackingNumber && trackingNumber.length < 20) {
      showFieldError(form, 'trackingNumber', 'Please enter a valid tracking number (20-22 digits).');
      valid = false;
    }

    // Skip photo validation if impressions were approved on Zoom
    if (!zoomApproved) {
      if (filesBox1.size === 0) {
        const box1 = form.querySelector('[data-upload-box="1"]');
        showErrorOnWrapper(box1, 'Please upload your impression photos.');
        valid = false;
      }
      if (guardSelection === '1 top & 1 bottom' && filesBox2.size === 0) {
        const box2 = form.querySelector('[data-upload-box="2"]');
        showErrorOnWrapper(box2, 'Please upload your second impression photos.');
        valid = false;
      }
    }

    if (!valid) scrollToFirstError(form);
    return valid;
  }

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function isUnderAge(dateString, minAge) {
    const dob = new Date(dateString);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age < minAge;
  }

  async function lookupCustomerByEmail(email, endpoint, welcomeModal, form) {
    try {
      const response = await fetch(`${endpoint}?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const result = await response.json();

      if (result.success) {
        if (result.orders && result.orders.length > 0) {
          // Has orders — show welcome modal so user can pick one
          populateWelcomeModal(welcomeModal, result, form);
          showWelcomeModal(welcomeModal);
        } else {
          // No orders but customer data found — auto-fill directly
          autoFillFromCustomerData(form, result, null);
        }
      }
    } catch (error) {
      console.log('Customer lookup failed:', error);
    }
  }

  function formatOrderDate(dateStr) {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function populateWelcomeModal(modal, data, form) {
    const orderList = modal.querySelector('[data-order-list]');
    if (!orderList) return;

    orderList.innerHTML = data.orders.map((order, index) => {
      // Determine impression status
      let statusText = 'Ready to submit';
      let statusClass = 'status--none';
      if (order.impressionSubmitted) {
        statusText = '\u2713 Previously submitted';
        statusClass = 'status--submitted';
      }

      const orderTitle = order.orderNumber
        ? `Order #${order.orderNumber} - ${order.productName || 'Night Guard'}`
        : order.productName || 'Night Guard';
      const orderMeta = order.orderDate ? `Ordered on ${formatOrderDate(order.orderDate)}` : '';

      return `
        <div class="impression-form-v2__order-option ${index === 0 ? 'is-selected' : ''}" data-order-option>
          <input type="radio" name="selectedOrder" value="${order.orderId}" class="impression-form-v2__order-radio" ${index === 0 ? 'checked' : ''}>
          <div class="impression-form-v2__order-info">
            <div class="impression-form-v2__order-title">${orderTitle}</div>
            <div class="impression-form-v2__order-meta">${orderMeta}</div>
            <div class="impression-form-v2__order-status ${statusClass}">${statusText}</div>
          </div>
        </div>
      `;
    }).join('');

    // Store customer data and orders for auto-fill
    modal.customerData = data;
    modal.ordersData = data.orders;

    // Update CTA button text based on selected order
    function updateSelectBtnText() {
      const selectBtn = modal.querySelector('[data-welcome-select]');
      if (!selectBtn) return;
      const selectedRadio = modal.querySelector('input[name="selectedOrder"]:checked');
      if (selectedRadio && data.orders) {
        const order = data.orders.find(o => o.orderId === selectedRadio.value);
        selectBtn.textContent = order && order.impressionSubmitted ? 'Submit Another Attempt' : 'Submit Impression';
      }
    }

    // Handle order option clicks
    orderList.querySelectorAll('[data-order-option]').forEach(option => {
      option.addEventListener('click', () => {
        orderList.querySelectorAll('[data-order-option]').forEach(o => o.classList.remove('is-selected'));
        option.classList.add('is-selected');
        option.querySelector('input[type="radio"]').checked = true;
        updateSelectBtnText();
      });
    });

    // Set initial CTA text
    updateSelectBtnText();
  }

  function initWelcomeModal(modal, form) {
    const closeBtn = modal.querySelector('[data-welcome-close]');
    const newBtn = modal.querySelector('[data-welcome-new]');
    const selectBtn = modal.querySelector('[data-welcome-select]');

    if (closeBtn) {
      closeBtn.addEventListener('click', () => hideWelcomeModal(modal));
    }

    if (newBtn) {
      newBtn.addEventListener('click', () => {
        hideWelcomeModal(modal);
      });
    }

    if (selectBtn) {
      selectBtn.addEventListener('click', () => {
        const selectedRadio = modal.querySelector('input[name="selectedOrder"]:checked');
        if (selectedRadio && modal.customerData) {
          const selectedOrder = modal.ordersData?.find(o => o.orderId === selectedRadio.value);
          autoFillFromCustomerData(form, modal.customerData, selectedOrder?.orderNumber || '');
        }
        hideWelcomeModal(modal);
      });
    }
  }

  function autoFillFromCustomerData(form, data, selectedOrderNumber) {
    // Auto-fill personal info
    if (data.firstName) setFieldValue(form, 'firstName', data.firstName);
    if (data.lastName) setFieldValue(form, 'lastName', data.lastName);
    if (data.phone) setFieldValue(form, 'phone', data.phone);
    if (data.dateOfBirth) {
      const [year, month, day] = data.dateOfBirth.split('-');
      const dobMonth = form.querySelector('[data-dob-month]');
      const dobDay = form.querySelector('[data-dob-day]');
      const dobYear = form.querySelector('[data-dob-year]');
      if (dobYear) dobYear.value = year;
      if (dobMonth) dobMonth.value = month;
      // Trigger day update for correct day count, then set day
      if (dobMonth) dobMonth.dispatchEvent(new Event('change', { bubbles: true }));
      if (dobDay) dobDay.value = day.padStart(2, '0');
      // Sync hidden input
      setFieldValue(form, 'dateOfBirth', data.dateOfBirth);
    }

    // Auto-fill shipping address
    if (data.shippingAddress) {
      setFieldValue(form, 'shippingAddress1', data.shippingAddress.street || '');
      setFieldValue(form, 'shippingAddress2', data.shippingAddress.street2 || '');
      setFieldValue(form, 'shippingCity', data.shippingAddress.city || '');
      // Use state combobox API if available, otherwise fallback to direct set
      const stateCode = data.shippingAddress.state || data.shippingAddress.stateCode || '';
      if (stateCode && form.stateComboboxAPI) {
        form.stateComboboxAPI.setState(stateCode, false);
      } else if (stateCode) {
        // Fallback: set both hidden and display inputs
        setFieldValue(form, 'shippingState', stateCode);
        const displayInput = form.querySelector('[data-state-input]');
        const stateObj = US_STATES.find(s => s.value === stateCode || s.value === stateCode.toUpperCase());
        if (displayInput && stateObj) {
          displayInput.value = stateObj.label;
        }
      }
      setFieldValue(form, 'shippingZip', data.shippingAddress.zip || '');
      if (data.shippingAddress.country) {
        setFieldValue(form, 'shippingCountry', data.shippingAddress.country);
      }
    }

    // Auto-fill order number
    if (selectedOrderNumber) {
      setFieldValue(form, 'orderNumber', selectedOrderNumber);
    }
  }

  function setFieldValue(form, fieldName, value) {
    const field = form.querySelector(`[name="${fieldName}"]`);
    if (field) {
      field.value = value;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function showWelcomeModal(modal) {
    if (modal) {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function hideWelcomeModal(modal) {
    if (modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  function initAgeWarningModal(modal, form) {
    const contactBtn = modal.querySelector('[data-age-warning-contact]');
    const continueBtn = modal.querySelector('[data-age-warning-continue]');

    if (contactBtn) {
      contactBtn.addEventListener('click', () => {
        const form = document.querySelector('[data-impression-form-v2]');
        const url = form?.dataset.contactLink || '/pages/contact';
        if (form?.dataset.openNewTab === 'true') {
          window.open(url, '_blank', 'noopener');
        } else {
          window.location.href = url;
        }
      });
    }

    if (continueBtn) {
      continueBtn.addEventListener('click', () => {
        hideAgeWarningModal(modal);
      });
    }
  }

  function showAgeWarningModal(modal) {
    if (modal) {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function hideAgeWarningModal(modal) {
    if (modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // Product card selection handler
  function initProductCards(form) {
    const productCards = form.querySelectorAll('[data-product]');
    const hiddenInput = form.querySelector('[data-selected-product]');
    const thicknessBar = form.querySelector('[data-thickness-bar]');
    const productNotes = form.querySelectorAll('[data-product-note]');

    productCards.forEach(card => {
      card.addEventListener('click', () => {
        productCards.forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');

        const product = card.dataset.product;
        if (hiddenInput) hiddenInput.value = product;

        // Hide all product notes, then show matching one
        productNotes.forEach(note => { note.style.display = 'none'; });
        const matchingNote = form.querySelector(`[data-product-note="${product}"]`);
        if (matchingNote) matchingNote.style.display = 'block';

        // Show/hide thickness bar based on product
        if (thicknessBar) {
          if (product === 'nightGuard') {
            thicknessBar.style.display = 'block';
          } else {
            thicknessBar.style.display = 'none';
            // Set 2mm for retainers and whitening trays
            const thicknessInput = form.querySelector('[data-guard-thickness]');
            if (thicknessInput) {
              thicknessInput.value = (product === 'retainers' || product === 'whiteningTrays') ? '2mm' : '1mm';
            }
          }
        }
      });
    });
  }

  // Guard selection -> dynamic backup options
  function initGuardSelection(form) {
    const guardSelect = form.querySelector('[name="guardSelection"]');
    const backupSelect = form.querySelector('[name="backupOption"]');
    const backupHint = form.querySelector('[data-backup-hint]');

    if (!guardSelect || !backupSelect) return;

    // Disable backup until first choice is selected
    backupSelect.disabled = true;

    guardSelect.addEventListener('change', () => {
      const selection = guardSelect.value;
      let options = '<option value="" disabled selected></option>';

      if (selection === '1 top & 1 bottom') {
        options += '<option value="2 tops">2 tops</option>';
        options += '<option value="2 bottoms">2 bottoms</option>';
      } else if (selection === '2 tops') {
        options += '<option value="1 top & 1 bottom">1 top & 1 bottom</option>';
        options += '<option value="2 bottoms">2 bottoms</option>';
      } else if (selection === '2 bottoms') {
        options += '<option value="1 top & 1 bottom">1 top & 1 bottom</option>';
        options += '<option value="2 tops">2 tops</option>';
      }

      backupSelect.innerHTML = options;
      backupSelect.disabled = false;
      if (backupHint) backupHint.style.display = 'none';

      // Also update photo upload boxes based on selection
      const uploadBoxes = form.querySelector('[data-upload-boxes]');
      const box1 = form.querySelector('[data-upload-box="1"]');
      const box2 = form.querySelector('[data-upload-box="2"]');
      updateUploadBoxes(selection, box1, box2, uploadBoxes, form);
    });
  }

  // Thickness bar selection
  function initThicknessBar(form) {
    const thicknessOptions = form.querySelectorAll('[data-thickness]');
    const hiddenInput = form.querySelector('[data-guard-thickness]');

    thicknessOptions.forEach(option => {
      option.addEventListener('click', () => {
        thicknessOptions.forEach(o => o.classList.remove('is-selected'));
        option.classList.add('is-selected');
        if (hiddenInput) hiddenInput.value = option.dataset.thickness;
        // Clear field-level error
        clearErrorOnWrapper(form.querySelector('[data-thickness-bar]'));
      });
    });
  }

  // Tracking number formatting (groups of 4 digits)
  function initTrackingNumberFormat(form) {
    const trackingInput = form.querySelector('[name="trackingNumber"]');
    if (!trackingInput) return;

    trackingInput.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      value = value.substring(0, 22);

      let formatted = '';
      for (let i = 0; i < value.length; i++) {
        if (i > 0 && i % 4 === 0) formatted += ' ';
        formatted += value[i];
      }

      e.target.value = formatted;
    });
  }

  // Phone number formatting
  function initPhoneFormat(form) {
    const phoneInput = form.querySelector('[name="phone"]');
    if (!phoneInput) return;

    phoneInput.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      value = value.substring(0, 10);

      if (value.length > 6) {
        value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
      } else if (value.length > 3) {
        value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
      } else if (value.length > 0) {
        value = `(${value}`;
      }

      e.target.value = value;
    });
  }

  // Date of birth dropdown initialization
  function initDobDropdowns(form) {
    const monthSelect = form.querySelector('[data-dob-month]');
    const daySelect = form.querySelector('[data-dob-day]');
    const yearSelect = form.querySelector('[data-dob-year]');
    const hiddenInput = form.querySelector('[name="dateOfBirth"]');

    if (!monthSelect || !daySelect || !yearSelect || !hiddenInput) return;

    // Populate year options (current year down to 1920)
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 1920; y--) {
      const opt = document.createElement('option');
      opt.value = y;
      opt.textContent = y;
      yearSelect.appendChild(opt);
    }

    // Populate day options based on month/year
    function updateDays() {
      const month = parseInt(monthSelect.value) || 0;
      const year = parseInt(yearSelect.value) || currentYear;
      const currentDay = daySelect.value;

      // Get days in selected month (0 = last day of previous month trick)
      const daysInMonth = month ? new Date(year, month, 0).getDate() : 31;

      daySelect.innerHTML = '<option value="" disabled selected> </option>';
      for (let d = 1; d <= daysInMonth; d++) {
        const opt = document.createElement('option');
        opt.value = String(d).padStart(2, '0');
        opt.textContent = d;
        daySelect.appendChild(opt);
      }

      // Restore previous day selection if still valid
      if (currentDay && parseInt(currentDay) <= daysInMonth) {
        daySelect.value = currentDay;
      }
    }

    // Sync dropdowns to hidden input
    function syncHiddenInput() {
      const m = monthSelect.value;
      const d = daySelect.value;
      const y = yearSelect.value;

      if (m && d && y) {
        hiddenInput.value = `${y}-${m}-${d}`;
      } else {
        hiddenInput.value = '';
      }
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Initialize days (default 31)
    updateDays();

    monthSelect.addEventListener('change', () => { updateDays(); syncHiddenInput(); });
    daySelect.addEventListener('change', syncHiddenInput);
    yearSelect.addEventListener('change', () => { updateDays(); syncHiddenInput(); });
  }

  // --- Field-Level Error Helpers ---

  function showFieldError(form, fieldName, message) {
    const field = form.querySelector(`[name="${fieldName}"]`);
    if (!field) return;
    const formControl = field.closest('.form-control');
    if (formControl) {
      formControl.classList.add('has-error');
      if (!formControl.querySelector('.impression-form-v2__field-error')) {
        const errorEl = document.createElement('span');
        errorEl.className = 'impression-form-v2__field-error';
        errorEl.textContent = message;
        formControl.appendChild(errorEl);
      }
    }
  }

  function showErrorOnWrapper(wrapper, message) {
    if (!wrapper) return;
    wrapper.classList.add('has-error');
    if (!wrapper.querySelector('.impression-form-v2__field-error')) {
      const errorEl = document.createElement('span');
      errorEl.className = 'impression-form-v2__field-error';
      errorEl.textContent = message;
      wrapper.appendChild(errorEl);
    }
  }

  function clearFieldError(form, fieldName) {
    const field = form.querySelector(`[name="${fieldName}"]`);
    if (!field) return;
    const formControl = field.closest('.form-control');
    if (formControl) {
      formControl.classList.remove('has-error');
      const errorEl = formControl.querySelector('.impression-form-v2__field-error');
      if (errorEl) errorEl.remove();
    }
  }

  function clearErrorOnWrapper(wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove('has-error');
    const errorEl = wrapper.querySelector('.impression-form-v2__field-error');
    if (errorEl) errorEl.remove();
  }

  function clearAllFieldErrors(form) {
    form.querySelectorAll('.has-error').forEach(el => el.classList.remove('has-error'));
    form.querySelectorAll('.impression-form-v2__field-error').forEach(el => el.remove());
  }

  function scrollToFirstError(form) {
    const firstError = form.querySelector('.has-error');
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function focusField(form, fieldName) {
    const field = form.querySelector(`[name="${fieldName}"]`);
    if (field) {
      field.focus();
    }
  }

  function initTooltips(form) {
    const tooltipTriggers = form.querySelectorAll('[data-tooltip-trigger]');

    tooltipTriggers.forEach(trigger => {
      const tooltip = trigger.nextElementSibling;
      if (!tooltip || !tooltip.classList.contains('impression-form-v2__tooltip')) return;

      // Handle click/tap for mobile
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Close all other tooltips first
        document.querySelectorAll('.impression-form-v2__tooltip.is-visible').forEach(t => {
          if (t !== tooltip) t.classList.remove('is-visible');
        });

        // Toggle this tooltip
        tooltip.classList.toggle('is-visible');
      });
    });

    // Close tooltips when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-tooltip-trigger]') && !e.target.closest('.impression-form-v2__tooltip')) {
        document.querySelectorAll('.impression-form-v2__tooltip.is-visible').forEach(t => {
          t.classList.remove('is-visible');
        });
      }
    });
  }

  function initUploadBox(box, filesMap, form) {
    const uploadArea = box.querySelector('[data-upload-area]');
    const fileInput = box.querySelector('[data-file-input]');
    const previewGrid = box.querySelector('[data-preview-grid]');
    const guideLink = box.querySelector('[data-guide-link]');

    if (!uploadArea || !fileInput || !previewGrid) return;

    // Click to upload — show upload guide popup first, then open file picker
    uploadArea.addEventListener('click', () => {
      const guideType = guideLink ? guideLink.dataset.guideType : 'top';
      openUploadGuide(form, fileInput, guideType);
    });

    // File input change
    fileInput.addEventListener('change', (e) => {
      handleFiles(e.target.files, previewGrid, uploadArea, filesMap, form);
      fileInput.value = ''; // Reset input to allow re-selecting same file
    });

    // Drag and drop
    uploadArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      uploadArea.classList.add('dragover');
    });

    uploadArea.addEventListener('dragleave', () => {
      uploadArea.classList.remove('dragover');
    });

    uploadArea.addEventListener('drop', (e) => {
      e.preventDefault();
      uploadArea.classList.remove('dragover');
      handleFiles(e.dataTransfer.files, previewGrid, uploadArea, filesMap, form);
    });

    // Guide link click
    if (guideLink) {
      guideLink.addEventListener('click', () => {
        const guideType = guideLink.dataset.guideType;
        openGuideModal(form, guideType);
      });
    }
  }

  function updateUploadBoxes(preference, box1, box2, uploadBoxes, form) {
    const config = LABEL_CONFIG[preference];
    if (!config) return;

    // Store current config on form for submission
    form.dataset.currentPreference = preference;

    // Update box 1 label and guide type
    const label1 = box1.querySelector('[data-upload-label]');
    const guideLink1 = box1.querySelector('[data-guide-link]');
    if (label1) {
      label1.innerHTML = `${config.box1.label} <span style="color: rgb(var(--error-color, 239, 68, 68));">*</span>`;
    }
    if (guideLink1) {
      guideLink1.dataset.guideType = config.box1.guideType;
    }

    // Show/hide box 2 based on preference
    if (config.showBox2 && config.box2) {
      // Update box 2 label and guide type
      const label2 = box2.querySelector('[data-upload-label]');
      const guideLink2 = box2.querySelector('[data-guide-link]');
      if (label2) {
        label2.innerHTML = `${config.box2.label} <span style="color: rgb(var(--error-color, 239, 68, 68));">*</span>`;
      }
      if (guideLink2) {
        guideLink2.dataset.guideType = config.box2.guideType;
      }
      box2.style.display = '';
      uploadBoxes.classList.remove('is-single-box');
    } else {
      // Hide box 2 and make box 1 full width
      box2.style.display = 'none';
      uploadBoxes.classList.add('is-single-box');
    }

    // Show upload boxes container
    uploadBoxes.classList.add('is-visible');
  }

  function openUploadGuide(form, fileInput, guideType) {
    const attrName = guideType === 'bottom' ? 'uploadGuideBottomSrc' : 'uploadGuideTopSrc';
    const uploadGuideSrc = form.dataset[attrName];
    if (!uploadGuideSrc) {
      // No upload guide image configured — open file picker directly
      fileInput.click();
      return;
    }

    const lightbox = form.closest('.impression-form-v2').querySelector('[data-lightbox]');
    if (!lightbox) {
      fileInput.click();
      return;
    }

    const image = lightbox.querySelector('[data-lightbox-image]');
    const description = lightbox.querySelector('[data-lightbox-description]');
    const thumbnailsContainer = lightbox.querySelector('[data-lightbox-thumbnails]');
    const gotItBtn = lightbox.querySelector('[data-lightbox-gotit]');

    // Set the upload guide image
    if (image) {
      image.src = uploadGuideSrc;
      image.alt = 'Photo upload guide';
    }

    // Hide description and thumbnails (single image, no gallery)
    if (description) description.style.display = 'none';
    if (thumbnailsContainer) {
      thumbnailsContainer.innerHTML = '';
      thumbnailsContainer.style.display = 'none';
    }

    // Store pending file input and show "Got it!" button
    lightbox.pendingFileInput = fileInput;
    if (gotItBtn) gotItBtn.style.display = 'block';

    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function openGuideModal(form, guideType, fileInput) {
    const lightbox = form.closest('.impression-form-v2').querySelector('[data-lightbox]');
    if (!lightbox) return;

    const image = lightbox.querySelector('[data-lightbox-image]');
    const description = lightbox.querySelector('[data-lightbox-description]');
    const thumbnailsContainer = lightbox.querySelector('[data-lightbox-thumbnails]');
    const gotItBtn = lightbox.querySelector('[data-lightbox-gotit]');

    // Parse guide data from form data attributes
    let guides = [];
    try {
      const guidesData = guideType === 'top' ? form.dataset.topGuides : form.dataset.bottomGuides;
      guides = JSON.parse(guidesData || '[]');
    } catch (e) {
      console.error('Error parsing guide data:', e);
    }

    if (!guides || guides.length === 0) {
      // No guide images — fall back to opening file picker directly
      if (fileInput) fileInput.click();
      return;
    }

    // Store pending file input for "Got it!" button
    lightbox.pendingFileInput = fileInput || null;

    // Show/hide "Got it!" button
    if (gotItBtn) {
      gotItBtn.style.display = fileInput ? 'block' : 'none';
    }

    // Store current index on lightbox for thumbnail navigation
    lightbox.dataset.currentIndex = '0';
    lightbox.dataset.guideType = guideType;

    // Set initial image and description
    if (image) {
      image.src = guides[0].src;
      image.alt = `${guideType.charAt(0).toUpperCase() + guideType.slice(1)} impression photo angle guide`;
    }
    if (description) {
      description.textContent = guides[0].description || '';
      description.style.display = guides[0].description ? 'block' : 'none';
    }

    // Generate thumbnails (only show if more than 1 image)
    if (thumbnailsContainer) {
      thumbnailsContainer.innerHTML = '';

      if (guides.length > 1) {
        guides.forEach((guide, index) => {
          const thumb = document.createElement('img');
          thumb.src = guide.thumb;
          thumb.alt = `Guide image ${index + 1}`;
          thumb.className = 'impression-form-v2__lightbox-thumb';
          if (index === 0) thumb.classList.add('is-active');
          thumb.dataset.index = index;

          thumb.addEventListener('click', () => {
            selectGuideImage(lightbox, guides, index);
          });

          thumbnailsContainer.appendChild(thumb);
        });
        thumbnailsContainer.style.display = 'flex';
      } else {
        thumbnailsContainer.style.display = 'none';
      }
    }

    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function selectGuideImage(lightbox, guides, index) {
    const image = lightbox.querySelector('[data-lightbox-image]');
    const description = lightbox.querySelector('[data-lightbox-description]');
    const thumbnails = lightbox.querySelectorAll('.impression-form-v2__lightbox-thumb');

    if (!guides[index]) return;

    // Update main image
    if (image) {
      // Reset zoom state
      image.classList.remove('is-zoomed');
      image.style.transformOrigin = '';
      // Update source
      image.src = guides[index].src;
    }

    // Update description
    if (description) {
      description.textContent = guides[index].description || '';
      description.style.display = guides[index].description ? 'block' : 'none';
    }

    // Update active thumbnail
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
    });

    // Store current index
    lightbox.dataset.currentIndex = index;
  }

  function initLightbox(lightbox, form) {
    const closeElements = lightbox.querySelectorAll('[data-lightbox-close]');
    const img = lightbox.querySelector('[data-lightbox-image]');
    const gotItBtn = lightbox.querySelector('[data-lightbox-gotit]');

    closeElements.forEach(el => {
      el.addEventListener('click', () => closeLightbox(lightbox));
    });

    // "Got it!" button — close guide and open file picker
    if (gotItBtn) {
      gotItBtn.addEventListener('click', () => {
        const pendingInput = lightbox.pendingFileInput;
        closeLightbox(lightbox);
        if (pendingInput) pendingInput.click();
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox(lightbox);
      }
    });

    // Click-to-zoom on lightbox image (no hover zoom)
    if (img) {
      // Track mouse position for pan while zoomed
      img.addEventListener('mousemove', (e) => {
        if (!img.classList.contains('is-zoomed')) return;
        const rect = img.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      });

      // Click: toggle zoom on/off
      img.addEventListener('click', (e) => {
        e.stopPropagation();
        if (img.classList.contains('is-zoomed')) {
          img.classList.remove('is-zoomed');
          img.style.transformOrigin = '';
        } else {
          img.classList.add('is-zoomed');
          const rect = img.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        }
      });
    }
  }

  function closeLightbox(lightbox) {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';

    // Reset zoom state on close
    const img = lightbox.querySelector('[data-lightbox-image]');
    if (img) {
      img.classList.remove('is-zoomed');
      img.style.transformOrigin = '';
    }

    // Reset gallery state
    lightbox.dataset.currentIndex = '0';
    delete lightbox.dataset.guideType;

    // Clear thumbnails
    const thumbnailsContainer = lightbox.querySelector('[data-lightbox-thumbnails]');
    if (thumbnailsContainer) {
      thumbnailsContainer.innerHTML = '';
    }

    // Clear description
    const description = lightbox.querySelector('[data-lightbox-description]');
    if (description) {
      description.textContent = '';
    }

    // Clear pending file input
    lightbox.pendingFileInput = null;
  }

  function openPreviewInLightbox(imageSrc, form) {
    const lightbox = form.closest('.impression-form-v2').querySelector('[data-lightbox]');
    if (!lightbox || !imageSrc) return;

    const image = lightbox.querySelector('[data-lightbox-image]');
    const description = lightbox.querySelector('[data-lightbox-description]');
    const thumbnailsContainer = lightbox.querySelector('[data-lightbox-thumbnails]');

    if (image) {
      image.src = imageSrc;
      image.alt = 'Uploaded image preview';
    }

    // Hide description and thumbnails for preview mode
    if (description) {
      description.style.display = 'none';
    }
    if (thumbnailsContainer) {
      thumbnailsContainer.style.display = 'none';
    }

    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function initThankYouModal(modal, form, filesBox1, filesBox2, uploadBoxes, onReset) {
    const closeButton = modal.querySelector('[data-thank-you-close]');
    const backdrop = modal.querySelector('.impression-form-v2__thank-you-backdrop');

    const closeHandler = () => {
      closeThankYouModal(modal, form, filesBox1, filesBox2, uploadBoxes, onReset);
    };

    if (closeButton) {
      closeButton.addEventListener('click', closeHandler);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeHandler);
    }

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeHandler();
      }
    });
  }

  function closeThankYouModal(modal, form, filesBox1, filesBox2, uploadBoxes, onReset) {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    resetForm(form, filesBox1, filesBox2, uploadBoxes);
    if (onReset) {
      onReset();
    }
  }

  function handleFiles(files, previewGrid, uploadArea, filesMap, form) {
    Array.from(files).forEach(file => {
      // Validate file type
      if (!ALLOWED_TYPES.includes(file.type) && !file.name.match(/\.(heic|heif)$/i)) {
        showError(form, `"${file.name}" is not a supported image format.`);
        return;
      }

      // Validate file size
      if (file.size > MAX_FILE_SIZE) {
        showError(form, `"${file.name}" exceeds the 10MB size limit.`);
        return;
      }

      // Generate unique ID for this file
      const fileId = `${file.name}-${file.size}-${Date.now()}-${Math.random()}`;

      // Store file
      filesMap.set(fileId, file);

      // Create preview
      createPreview(file, fileId, previewGrid, uploadArea, filesMap, form);
    });

    updateUploadAreaState(uploadArea, filesMap);
    // Clear upload box error when files are added
    const uploadBox = uploadArea.closest('[data-upload-box]');
    if (uploadBox && filesMap.size > 0) clearErrorOnWrapper(uploadBox);
  }

  function createPreview(file, fileId, previewGrid, uploadArea, filesMap, form) {
    const item = document.createElement('div');
    item.className = 'impression-form-v2__preview-item';
    item.dataset.fileId = fileId;

    // Create image preview
    const img = document.createElement('img');
    img.alt = file.name;

    // Handle HEIC files (show placeholder)
    if (file.name.match(/\.(heic|heif)$/i)) {
      img.src = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect fill="#f0f0f0" width="100" height="100"/><text x="50" y="55" text-anchor="middle" font-size="12" fill="#666">HEIC</text></svg>');
    } else {
      const reader = new FileReader();
      reader.onload = (e) => {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    // Add click to zoom
    img.addEventListener('click', () => {
      if (img.src && !img.src.includes('data:image/svg+xml')) {
        openPreviewInLightbox(img.src, form);
      }
    });

    item.appendChild(img);

    // Create remove button
    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'impression-form-v2__preview-remove';
    removeBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 2l12 12M14 2L2 14"/></svg>';
    removeBtn.setAttribute('aria-label', 'Remove photo');
    removeBtn.addEventListener('click', () => {
      filesMap.delete(fileId);
      item.remove();
      updateUploadAreaState(uploadArea, filesMap);
    });

    item.appendChild(removeBtn);
    previewGrid.appendChild(item);
  }

  function updateUploadAreaState(uploadArea, filesMap) {
    if (filesMap.size > 0) {
      uploadArea.classList.add('has-files');
    } else {
      uploadArea.classList.remove('has-files');
    }
  }

  async function submitForm(form, filesBox1, filesBox2, thankYouModal) {
    const endpoint = form.dataset.salesforceEndpoint;

    if (!endpoint) {
      showError(form, 'Form is not configured. Please contact support.');
      return;
    }

    // Get form values
    const firstName = form.querySelector('[name="firstName"]')?.value.trim();
    const lastName = form.querySelector('[name="lastName"]')?.value.trim();
    const email = form.querySelector('[name="email"]')?.value.trim();
    const orderNumber = form.querySelector('[name="orderNumber"]')?.value.trim();
    const preferences = form.querySelector('[name="guardSelection"]')?.value;
    const zoomApproved = form.querySelector('[data-zoom-approved]')?.checked || false;

    // Get config for current preference
    const config = LABEL_CONFIG[preferences];

    // Show loading state
    setLoading(form, true);
    hideMessages(form);

    try {
      // Helper to compress and convert files to base64 array
      const filesToBase64Array = async (filesMap) => {
        const files = [...filesMap.values()];
        return Promise.all(
          files.map(async (file) => {
            const compressed = await compressImage(file);
            const base64 = await fileToBase64(compressed);
            return {
              name: compressed.name,
              base64: base64.split(',')[1] // Remove data URL prefix
            };
          })
        );
      };

      // Build photos arrays based on preference config (skip if zoom approved)
      let topPhotos = [];
      let bottomPhotos = [];

      if (!zoomApproved && config) {
        // Box 1 photos
        const box1Photos = await filesToBase64Array(filesBox1);
        if (config.box1.photoType === 'top') {
          topPhotos = topPhotos.concat(box1Photos);
        } else {
          bottomPhotos = bottomPhotos.concat(box1Photos);
        }

        // Box 2 photos (only if shown)
        if (config.showBox2 && config.box2) {
          const box2Photos = await filesToBase64Array(filesBox2);
          if (config.box2.photoType === 'top') {
            topPhotos = topPhotos.concat(box2Photos);
          } else {
            bottomPhotos = bottomPhotos.concat(box2Photos);
          }
        }
      }

      // Build request body with all fields per IMPRESSION-FORM-PLAN.md
      const body = {
        // Personal Info (Stage 1)
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: form.querySelector('[name="phone"]')?.value.trim() || null,
        dateOfBirth: form.querySelector('[name="dateOfBirth"]')?.value || null,
        smsOptIn: form.querySelector('[name="smsOptIn"]')?.checked || false,

        // Shipping Address (Stage 2)
        shippingAddress: {
          street: form.querySelector('[name="shippingAddress1"]')?.value.trim() || '',
          street2: form.querySelector('[name="shippingAddress2"]')?.value.trim() || '',
          city: form.querySelector('[name="shippingCity"]')?.value.trim() || '',
          state: form.querySelector('[name="shippingState"]')?.value.trim() || '',
          zip: form.querySelector('[name="shippingZip"]')?.value.trim() || '',
          country: form.querySelector('[name="shippingCountry"]')?.value.trim() || 'US'
        },

        // Order Details (Stage 3)
        selectedProduct: form.querySelector('[data-selected-product]')?.value || 'nightGuard',
        guardSelection: form.querySelector('[name="guardSelection"]')?.value || null,
        backupOption: form.querySelector('[name="backupOption"]')?.value || null,
        guardThicknessPreference: form.querySelector('[data-guard-thickness]')?.value || null,
        excludePartialCaptureMolars: form.querySelector('[name="excludePartialMolars"]')?.checked || false,
        isGift: form.querySelector('[name="isGift"]')?.checked || false,

        // Photos & Return Info (Stage 4)
        orderNumber: orderNumber,
        attemptType: '1st Attempt',
        impressionsApprovedOnZoom: zoomApproved,
        trackingNumber: form.querySelector('[name="trackingNumber"]')?.value.replace(/\s/g, '') || null,
        notes: form.querySelector('[name="notes"]')?.value.trim() || null,
        topPhotos: topPhotos,
        bottomPhotos: bottomPhotos
      };

      // Submit to Salesforce
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      let result;
      try {
        result = await response.json();
      } catch (parseError) {
        console.error('Failed to parse response (HTTP ' + response.status + '):', parseError);
        showError(form, 'Server returned an invalid response (HTTP ' + response.status + '). Please try again or contact support.');
        setLoading(form, false);
        return;
      }

      if (result.success) {
        const confirmationNumber = result.confirmationNumber || result.caseNumber || '---';
        showThankYouModal(thankYouModal, confirmationNumber);
      } else {
        console.error('Submission failed:', { message: result.message, errorType: result.errorType, errorDetail: result.errorDetail });
        showError(form, 'Something went wrong while submitting your impressions. Please try again or contact support.');
      }

    } catch (error) {
      console.error('Submission error:', error);
      showError(form, 'Something went wrong. Please check your connection and try again.');
    } finally {
      setLoading(form, false);
    }
  }

  function compressImage(file, maxDimension, quality) {
    maxDimension = maxDimension || 1600;
    quality = quality || 0.8;
    return new Promise(function(resolve) {
      if (file.name.match(/\.(heic|heif)$/i)) {
        resolve(file);
        return;
      }
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function() {
        URL.revokeObjectURL(url);
        var width = img.width;
        var height = img.height;
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = Math.round(height * maxDimension / width);
            width = maxDimension;
          } else {
            width = Math.round(width * maxDimension / height);
            height = maxDimension;
          }
        }
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob(function(blob) {
          resolve(new File([blob], file.name.replace(/\.\w+$/, '.jpg'), { type: 'image/jpeg' }));
        }, 'image/jpeg', quality);
      };
      img.onerror = function() {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    });
  }

  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function setLoading(form, isLoading) {
    const submitBtn = form.querySelector('button[type="submit"]');
    const submitText = form.querySelector('.impression-form-v2__submit-text');
    const loadingEl = form.querySelector('.impression-form-v2__loading');

    if (submitBtn) {
      submitBtn.disabled = isLoading;
    }
    if (submitText) {
      submitText.classList.toggle('is-hidden', isLoading);
    }
    if (loadingEl) {
      loadingEl.classList.toggle('is-visible', isLoading);
    }
  }

  function hideMessages(form) {
    const errorBanner = form.querySelector('.impression-form-v2__error-banner');
    if (errorBanner) errorBanner.style.display = 'none';
  }

  function showThankYouModal(modal, confirmationNumber) {
    if (modal) {
      // Display confirmation number
      const confirmationEl = modal.querySelector('[data-confirmation-number]');
      if (confirmationEl && confirmationNumber) {
        confirmationEl.textContent = confirmationNumber;
      }
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function showError(form, message) {
    const errorBanner = form.querySelector('.impression-form-v2__error-banner');
    if (errorBanner) {
      const escapedMessage = escapeHtml(message).replace(/\n/g, '<br>');
      errorBanner.innerHTML = `
        <div class="banner banner--error" style="white-space: pre-wrap;">
          <svg class="offset-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
            <path d="M10 6v5M10 13v1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          ${escapedMessage}
        </div>
      `;
      errorBanner.style.display = 'block';
      errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function resetForm(form, filesBox1, filesBox2, uploadBoxes) {
    // Reset form fields
    form.reset();

    // Clear file previews for both boxes
    const previewGrids = form.querySelectorAll('[data-preview-grid]');
    previewGrids.forEach(grid => {
      grid.innerHTML = '';
    });

    // Clear selected files from both boxes
    filesBox1.clear();
    filesBox2.clear();

    // Reset upload area states
    const uploadAreas = form.querySelectorAll('[data-upload-area]');
    uploadAreas.forEach(area => {
      area.classList.remove('has-files');
    });

    // Reset box2 display (in case it was hidden)
    const box2 = form.querySelector('[data-upload-box="2"]');
    if (box2) {
      box2.style.display = '';
    }

    // Clear stored preference
    delete form.dataset.currentPreference;

    // Hide upload boxes (will show again when preference is selected)
    if (uploadBoxes) {
      uploadBoxes.classList.remove('is-visible');
      uploadBoxes.classList.remove('is-single-box');
    }

    // Hide any error messages
    hideMessages(form);
    clearAllFieldErrors(form);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
